import { render, staticRenderFns } from "./BleConfig.vue?vue&type=template&id=68605cd4&scoped=true&"
import script from "./BleConfig.vue?vue&type=script&lang=js&"
export * from "./BleConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68605cd4",
  null
  
)

export default component.exports